import login from './login';

export default {
  language: 'da',
  country: 'dk',
  name: 'Dansk',
  embeddedLocale: login,
  flags: ['DK'],
};
